function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "my password");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M968.81006,506.95174c-5.27,45.15-16.22,81.4-31.25,110.31-20.00006,38.52-54.21008,54.04-84.77008,70.28a193.27677,193.27677,0,0,1-27.46,11.94c-55.61,19.3-117.85,14.18-166.74,3.99a657.297,657.297,0,0,0-104.09-13.16q-14.97-.67493-29.97-.67c-15.42.02-293.07,5.29-360.67-131.57-16.69-33.76-28.13-75-32.24-125.27-11.63-142.12,52.29-235.46,134.74-296.47,155.97-115.41,369.76-110.57,523.43,7.88C892.15,223.11178,987.99,342.52175,968.81006,506.95174Z",
  transform: "translate(-120 -52.50941)",
  fill: "#f2f2f2"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M420,465.80655c0,112.96734-67.15729,152.41131-150,152.41131s-150-39.444-150-152.41131S270,209.127,270,209.127,420,352.83922,420,465.80655Z",
  transform: "translate(-120 -52.50941)",
  fill: "#00c968"
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  points: "144.536 548.428 146.072 453.884 210.006 336.921 146.313 439.053 147.003 396.543 191.066 311.921 147.186 385.293 147.186 385.293 148.428 308.836 195.612 241.466 148.623 296.813 149.399 156.618 144.522 342.211 144.923 334.555 96.951 261.126 144.154 349.252 139.684 434.642 139.551 432.375 84.248 355.102 139.383 440.382 138.824 451.061 138.724 451.221 138.77 452.098 127.43 668.739 142.581 668.739 144.399 556.84 199.399 471.769 144.536 548.428",
  fill: "#3f3d56"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M1080,472.80655c0,112.96734-67.15729,152.41131-150,152.41131s-150-39.444-150-152.41131S930,216.127,930,216.127,1080,359.83922,1080,472.80655Z",
  transform: "translate(-120 -52.50941)",
  fill: "#00c968"
});

var _ref7 = /*#__PURE__*/React.createElement("polygon", {
  points: "804.536 555.428 806.072 460.884 870.006 343.921 806.313 446.053 807.003 403.543 851.066 318.921 807.186 392.293 807.186 392.293 808.428 315.836 855.612 248.466 808.623 303.813 809.399 163.618 804.522 349.211 804.923 341.555 756.951 268.126 804.154 356.252 799.684 441.642 799.551 439.375 744.248 362.102 799.383 447.382 798.824 458.061 798.724 458.221 798.77 459.098 787.43 675.739 802.581 675.739 804.399 563.84 859.399 478.769 804.536 555.428",
  fill: "#3f3d56"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M768,376.86433c0,123.51095-73.4253,166.63636-164,166.63636S440,500.37528,440,376.86433,604,96.228,604,96.228,768,253.35337,768,376.86433Z",
  transform: "translate(-120 -52.50941)",
  fill: "#00c968"
});

var _ref9 = /*#__PURE__*/React.createElement("polygon", {
  points: "478.026 472.098 479.705 368.73 549.606 240.85 479.969 352.515 480.724 306.037 528.899 213.517 480.923 293.737 480.923 293.737 482.281 210.144 533.869 136.486 482.495 196.999 483.343 43.719 478.011 246.634 478.449 238.263 426 157.981 477.608 254.332 472.721 347.692 472.576 345.213 412.111 260.729 472.393 353.968 471.781 365.643 471.672 365.819 471.722 366.777 459.323 603.638 475.889 603.638 477.876 481.295 538.01 388.284 478.026 472.098",
  fill: "#3f3d56"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M952,738.49059c0,26.50967-173.71352,109-388,109s-388-82.49033-388-109,159.71352-86,374-86S952,711.98092,952,738.49059Z",
  transform: "translate(-120 -52.50941)",
  fill: "#3f3d56"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M952,738.49059c0,26.50967-173.71352,109-388,109s-388-82.49033-388-109,159.71352-86,374-86S952,711.98092,952,738.49059Z",
  transform: "translate(-120 -52.50941)",
  opacity: 0.1
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M952,738.49059c0,26.50967-173.71352,48-388,48s-388-21.49033-388-48,159.71352-86,374-86S952,711.98092,952,738.49059Z",
  transform: "translate(-120 -52.50941)",
  fill: "#3f3d56"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M694.42886,605.57113c0,38.029,23.85743,68.80166,53.34062,68.80166",
  transform: "translate(-120 -52.50941)",
  fill: "#3f3d56"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M747.76948,674.37279c0-38.45634,26.6235-69.57472,59.525-69.57472",
  transform: "translate(-120 -52.50941)",
  fill: "#00c968"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M713.75517,609.01852c0,36.12355,15.21343,65.35427,34.01431,65.35427",
  transform: "translate(-120 -52.50941)",
  fill: "#00c968"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M747.76948,674.37279c0-49.13865,30.77261-88.901,68.80166-88.901",
  transform: "translate(-120 -52.50941)",
  fill: "#3f3d56"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M736.548,674.85785s7.56457-.233,9.84434-1.85638,11.63623-3.56182,12.20179-.95825,11.36815,12.949,2.82778,13.01787-19.844-1.3303-22.11941-2.71632S736.548,674.85785,736.548,674.85785Z",
  transform: "translate(-120 -52.50941)",
  fill: "#a8a8a8"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M761.57431,684.15477c-8.54037.06891-19.844-1.33028-22.1194-2.71631-1.73283-1.05554-2.42334-4.843-2.65438-6.59046-.16.00688-.25254.00984-.25254.00984s.47912,6.10089,2.75451,7.48692,13.579,2.78522,22.1194,2.71631c2.46527-.01988,3.31682-.897,3.27006-2.19605C764.34948,683.64988,763.40924,684.14,761.57431,684.15477Z",
  transform: "translate(-120 -52.50941)",
  opacity: 0.2
});

var _ref19 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 449,
  cy: 680.98118,
  rx: 132,
  ry: 21,
  opacity: 0.1
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  x: 494,
  y: 633.98118,
  width: 13,
  height: 30,
  fill: "#ffb9b9"
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  x: 458,
  y: 228.98118,
  width: 50,
  height: 90,
  fill: "#ff6584"
});

var _ref22 = /*#__PURE__*/React.createElement("polygon", {
  points: "544.721 399.312 546.451 413.157 500.88 427.001 495.111 401.62 544.721 399.312",
  fill: "#ffb9b9"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M597.22869,318.56875s-1.15371,10.38336-3.46112,10.38336-10.38337,4.038-10.38337,4.038l-2.30741,10.96021,16.1519,9.80651,26.53526-2.88426,7.49909-11.53707-7.49909-7.4991s-6.34539-13.84448-4.038-16.72875S597.22869,318.56875,597.22869,318.56875Z",
  transform: "translate(-120 -52.50941)",
  fill: "#ffb9b9"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M597.22869,318.56875s-1.15371,10.38336-3.46112,10.38336-10.38337,4.038-10.38337,4.038l-2.30741,10.96021,16.1519,9.80651,26.53526-2.88426,7.49909-11.53707-7.49909-7.4991s-6.34539-13.84448-4.038-16.72875S597.22869,318.56875,597.22869,318.56875Z",
  transform: "translate(-120 -52.50941)",
  opacity: 0.1
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M525.122,677.94849s-5.19168,34.61121-11.53707,36.91862,24.22784,6.34539,24.22784,6.34539l2.30742-12.69078s.57685-23.07414,2.88427-26.53526S525.122,677.94849,525.122,677.94849Z",
  transform: "translate(-120 -52.50941)",
  fill: "#ffb9b9"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M583.96106,476.62661s83.64375-14.99819,84.22061-17.88246,17.3056,21.92044,6.92224,70.37613S638.76214,691.793,638.76214,691.793s-26.53526,8.076-25.95841,1.73056,9.22966-116.52441,9.22966-116.52441L616.26485,530.274l-9.80651,5.76853L565.50174,616.802,544.735,686.60129s-26.53526,4.61483-22.49729-5.19168,17.30561-85.95118,17.30561-85.95118l36.34177-107.29475S574.7314,476.62661,583.96106,476.62661Z",
  transform: "translate(-120 -52.50941)",
  fill: "#2f2e41"
});

var _ref27 = /*#__PURE__*/React.createElement("circle", {
  cx: 485.01621,
  cy: 249.61901,
  r: 24.22785,
  fill: "#ffb9b9"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M630.10934,332.41323s-11.53707,10.96022-38.64919,8.07595,7.4991,61.72333,7.4991,61.72333L609.91946,467.397s48.4557-5.76853,50.18626-16.72875S630.10934,332.41323,630.10934,332.41323Z",
  transform: "translate(-120 -52.50941)",
  fill: "#f2f2f2"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M618.57227,394.13656s-13.84449-6.92224-19.03617-25.95841-9.80651-38.64918-12.69078-38.07233c-2.43527.48705-25.021,9.1988-32.34111,15.02428-1.34961,1.074-2.1803,2.05-2.2701,2.85818-.57685,5.19168,20.76673,57.1085,20.76673,57.1085s16.72875,37.49547,9.80651,49.6094-7.4991,27.689,5.19168,26.53526,54.80108-3.46112,49.03255-35.76492c0,0,10.96021,22.49729,41.53345,6.34539,0,0,18.45931-2.88427,17.88246-9.22966S667.028,381.44578,667.028,381.44578s-4.61483-24.22785,4.038-33.4575l-19.613-23.07414s-4.61483-6.92224-9.22966-3.46112-14.99819,9.22965-16.72875,9.80651-2.86829-2.07331-2.86829-2.07331a50.15409,50.15409,0,0,0-4.63081,26.878C619.726,371.06242,618.57227,394.13656,618.57227,394.13656Z",
  transform: "translate(-120 -52.50941)",
  fill: "#2f2e41"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M526.85256,707.94487s-1.28794-4.038-8.71992,0c0,0,2.37453-12.69078-5.70142-12.69078S501.471,710.25228,501.471,710.25228s-2.30741,9.80651-17.88246,13.84449-3.46112,17.88245,7.4991,17.88245,25.38155-8.6528,25.38155-8.6528,29.99639.57686,30.57324-5.19168-2.88427-23.07414-5.19168-23.07414-6.92224,8.076-6.92224,8.076Z",
  transform: "translate(-120 -52.50941)",
  fill: "#2f2e41"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M624.91765,697.793s-8.07594-8.6528-12.69077,5.76853-8.076,20.18988-5.19168,22.49729,5.19168,1.15371,4.038,5.76854,3.46112,14.42133,13.84448,14.42133,13.26764-7.49909,12.69078-12.69077-5.19168-11.53707-5.19168-11.53707l-4.61483-16.1519Z",
  transform: "translate(-120 -52.50941)",
  fill: "#2f2e41"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M670.48908,292.03349l-30.57323,10.38336s-27.689,16.1519-15.57505,19.613,22.49729-10.38336,22.49729-10.38336l26.53526-6.92224Z",
  transform: "translate(-120 -52.50941)",
  fill: "#ffb9b9"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M588.5317,264.66341c-3.6299,2.48667-6.51953,5.89268-9.267,9.32942-5.58253,6.98308-11.05227,15.323-9.6768,24.15683.52241,3.35517,2.01351,6.47776,2.853,9.76793,1.133,4.44034,1.05834,9.08738.9765,13.66925a18.4591,18.4591,0,0,1-.715,5.76366,37.99064,37.99064,0,0,1-2.84235,5.25447c-2.77828,5.17472-2.84644,11.3233-2.84876,17.19668a14.66559,14.66559,0,0,0,.79084,5.83156c.7586,1.766,2.17085,3.15066,3.342,4.67464a20.16514,20.16514,0,0,1,3.1082,18.26869,7.91386,7.91386,0,0,0,7.19-4.53355,10.02364,10.02364,0,0,1-2.56309,8.15237c6.60337-1.9624,13.68191-5.27107,16.0922-11.72445a24.84682,24.84682,0,0,0,1.18508-6.77594c1.28208-16.18765,2.0142-32.98059-3.79134-48.14566-1.85741-4.85187-4.38532-9.54824-5.008-14.706s1.28076-11.11815,6.01928-13.24818a5.46383,5.46383,0,0,0,1.6502,3.476c1.05467.78308,3.00509.2919,3.02418-1.02156l2.28881,3.18683a5.59164,5.59164,0,0,0,2.17351-1.8961l1.5691,1.92085,3.3374-2.42766,2.89784,3.12519a6.16615,6.16615,0,0,0,2.54433-2.7689c.62282.93147,1.39371,1.95519,2.50968,2.056,2.43009.21961,2.93162-3.63681,5.05451-4.8397a3.58263,3.58263,0,0,1,4.47152,1.35532,7.29918,7.29918,0,0,1,.90012,4.94257c-.87852,7.93214-7.64657,15.17-5.63989,22.89424,1.12838,4.34341,4.92876,7.82614,5.21543,12.30455.2291,3.579-1.87475,6.96477-1.8426,10.551.03768,4.20274,2.94145,7.77244,5.77615,10.87548q7.56762,8.284,15.93063,15.79162l-1.72232-3.01322a5.59237,5.59237,0,0,1,4.38587,1.613c.49508-1.732-.32558-3.53665-1.10006-5.163-4.63767-9.73871-8.38185-20.10833-8.94113-30.88042-.7774-14.97342,4.60637-30.18,1.19448-44.78024a38.65541,38.65541,0,0,0-13.02863-20.8277c-3.1557-2.59772-5.54843-4.15371-9.635-4.44a72.72067,72.72067,0,0,0-13.72491.10768A31.41756,31.41756,0,0,0,588.5317,264.66341Z",
  transform: "translate(-120 -52.50941)",
  fill: "#ff6584"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M646.83809,325.491s6.34539.57686,9.22965,0,6.92225-3.46112,6.92225-3.46112l21.92043-16.1519-19.03617,2.88427s3.46112-26.53526,2.30742-27.11212,55.95479-11.53707,54.80108,6.34539-33.4575,53.07053-51.91681,59.99277L658.952,349.71884Z",
  transform: "translate(-120 -52.50941)",
  fill: "#2f2e41"
});

var _ref35 = /*#__PURE__*/React.createElement("rect", {
  x: 317,
  y: 477.49059,
  width: 272,
  height: 64,
  fill: "#fff"
});

var _ref36 = /*#__PURE__*/React.createElement("rect", {
  x: 351.5,
  y: 491.99059,
  width: 202,
  height: 34,
  fill: "#3f3d56"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M518.44238,560.754c-.08081-.87183-3.937-1.25983-9.2279-1.04151,3.06592-4.31744,4.84167-7.76239,4.15466-8.30523-.64807-.512-3.30017,1.70147-6.5293,5.29632C506.53467,551.881,505.82593,548.5,505,548.5c-.90088,0-1.66235,4.02258-1.9126,9.55133-4.49316-3.2312-8.12158-5.12756-8.68017-4.42059-.53321.675,1.89526,3.52563,5.75586,6.93579-5.09522.75592-8.68482,1.82294-8.60547,2.67944.08081.87183,3.937,1.25989,9.2279,1.04157-3.06592,4.31744-4.84167,7.76239-4.15466,8.30517.64807.512,3.30017-1.70141,6.5293-5.29626C503.46533,572.11908,504.17407,575.5,505,575.5c.90088,0,1.66235-4.02271,1.9126-9.55139,4.49316,3.2312,8.12158,5.12756,8.68017,4.42059.53321-.675-1.89526-3.52563-5.75586-6.93579C514.93213,562.67743,518.52173,561.61047,518.44238,560.754Z",
  transform: "translate(-120 -52.50941)",
  fill: "#fff"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M552.44238,560.754c-.08081-.87183-3.937-1.25983-9.2279-1.04151,3.06592-4.31744,4.84167-7.76239,4.15466-8.30523-.64807-.512-3.30017,1.70147-6.5293,5.29632C540.53467,551.881,539.82593,548.5,539,548.5c-.90088,0-1.66235,4.02258-1.9126,9.55133-4.49316-3.2312-8.12158-5.12756-8.68017-4.42059-.53321.675,1.89526,3.52563,5.75586,6.93579-5.09522.75592-8.68482,1.82294-8.60547,2.67944.08081.87183,3.937,1.25989,9.2279,1.04157-3.06592,4.31744-4.84167,7.76239-4.15466,8.30517.64807.512,3.30017-1.70141,6.5293-5.29626C537.46533,572.11908,538.17407,575.5,539,575.5c.90088,0,1.66235-4.02271,1.9126-9.55139,4.49316,3.2312,8.12158,5.12756,8.68017,4.42059.53321-.675-1.89526-3.52563-5.75586-6.93579C548.93213,562.67743,552.52173,561.61047,552.44238,560.754Z",
  transform: "translate(-120 -52.50941)",
  fill: "#fff"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M586.44238,560.754c-.08081-.87183-3.937-1.25983-9.2279-1.04151,3.06592-4.31744,4.84167-7.76239,4.15466-8.30523-.64807-.512-3.30017,1.70147-6.5293,5.29632C574.53467,551.881,573.82593,548.5,573,548.5c-.90088,0-1.66235,4.02258-1.9126,9.55133-4.49316-3.2312-8.12158-5.12756-8.68017-4.42059-.53321.675,1.89526,3.52563,5.75586,6.93579-5.09522.75592-8.68482,1.82294-8.60547,2.67944.08081.87183,3.937,1.25989,9.2279,1.04157-3.06592,4.31744-4.84167,7.76239-4.15466,8.30517.64807.512,3.30017-1.70141,6.5293-5.29626C571.46533,572.11908,572.17407,575.5,573,575.5c.90088,0,1.66235-4.02271,1.9126-9.55139,4.49316,3.2312,8.12158,5.12756,8.68017,4.42059.53321-.675-1.89526-3.52563-5.75586-6.93579C582.93213,562.67743,586.52173,561.61047,586.44238,560.754Z",
  transform: "translate(-120 -52.50941)",
  fill: "#fff"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M620.44238,560.754c-.08081-.87183-3.937-1.25983-9.2279-1.04151,3.06592-4.31744,4.84167-7.76239,4.15466-8.30523-.64807-.512-3.30017,1.70147-6.5293,5.29632C608.53467,551.881,607.82593,548.5,607,548.5c-.90088,0-1.66235,4.02258-1.9126,9.55133-4.49316-3.2312-8.12158-5.12756-8.68017-4.42059-.53321.675,1.89526,3.52563,5.75586,6.93579-5.09522.75592-8.68482,1.82294-8.60547,2.67944.08081.87183,3.937,1.25989,9.2279,1.04157-3.06592,4.31744-4.84167,7.76239-4.15466,8.30517.64807.512,3.30017-1.70141,6.5293-5.29626C605.46533,572.11908,606.17407,575.5,607,575.5c.90088,0,1.66235-4.02271,1.9126-9.55139,4.49316,3.2312,8.12158,5.12756,8.68017,4.42059.53321-.675-1.89526-3.52563-5.75586-6.93579C616.93213,562.67743,620.52173,561.61047,620.44238,560.754Z",
  transform: "translate(-120 -52.50941)",
  fill: "#fff"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M654.44238,560.754c-.08081-.87183-3.937-1.25983-9.2279-1.04151,3.06592-4.31744,4.84167-7.76239,4.15466-8.30523-.64807-.512-3.30017,1.70147-6.5293,5.29632C642.53467,551.881,641.82593,548.5,641,548.5c-.90088,0-1.66235,4.02258-1.9126,9.55133-4.49316-3.2312-8.12158-5.12756-8.68017-4.42059-.53321.675,1.89526,3.52563,5.75586,6.93579-5.09522.75592-8.68482,1.82294-8.60547,2.67944.08081.87183,3.937,1.25989,9.2279,1.04157-3.06592,4.31744-4.84167,7.76239-4.15466,8.30517.64807.512,3.30017-1.70141,6.5293-5.29626C639.46533,572.11908,640.17407,575.5,641,575.5c.90088,0,1.66235-4.02271,1.9126-9.55139,4.49316,3.2312,8.12158,5.12756,8.68017,4.42059.53321-.675-1.89526-3.52563-5.75586-6.93579C650.93213,562.67743,654.52173,561.61047,654.44238,560.754Z",
  transform: "translate(-120 -52.50941)",
  fill: "#fff"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M548.773,502.585s-2.88427,38.07233,10.96022,39.80289,1.15371-43.264,1.15371-43.264Z",
  transform: "translate(-120 -52.50941)",
  fill: "#ffb9b9"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M556.27209,346.83457l-4.038,1.15371s-16.72875,133.83-5.76853,159.78842c0,0,11.53707-6.34539,17.3056-5.19168l9.22966-109.02531Z",
  transform: "translate(-120 -52.50941)",
  fill: "#2f2e41"
});

var SvgPassword = function SvgPassword(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f7dcc58f-beb5-4050-9d04-9a029c12a87b",
    "data-name": "Layer 1",
    width: 960,
    height: 794.98118,
    viewBox: "0 0 960 794.98118",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPassword, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/password.2545a51e.svg";
export { ForwardRef as ReactComponent };